import IncomeStatistics from "./IncomeStatistics"
export default IncomeStatistics
